import {
  isCNPJ,
  isValidBrazilEmailFormat
} from '@/global/utils/validation-schema'
import { z } from 'zod'

const meCompanyFormSchema = z.object({
  responsibleName: z
    .string({ message: 'Nome inválido' })
    .min(3, 'O nome deve conter ao menos 3 letras'),
  responsibleEmail: z
    .string()
    .email('E-mail inválido')
    .refine(isValidBrazilEmailFormat, { message: 'E-mail inválido' }),
  telefone: z
    .string({ message: 'Número de telefone inválido' })
    .min(11, 'O número de telefone está incompleto'),
  cnpj: z
    .string({ message: 'CNPJ Inválido' })
    .refine(isCNPJ, { message: 'CNPJ Inválido' }),
  city: z.string()
})

export { meCompanyFormSchema }
